import { classnames as cx } from "@mna/react";
import Form from "@mna/react-ui/Form";
import moment from "moment/moment.js";
import SelectGender from "./SelectGender";
import SelectBirthDate from "./SelectBirthDate";
import SelectPregnancyStatus from "./SelectPregnancyStatus";
import SelectRecentPhysicalInjury from "./SelectRecentPhysicalInjury";
import SelectChildBirth from "./SelectChildBirth";
import TriageSymptom from "./TriageSymptom";
import { Trans } from "react-i18next";
import schema from "@mna/schema";
import {  checkAndGetLocalStorageValue} from "../../../features/utils";

function isFemaleAlreadyPregnant({ fieldProps, state }) {
  var isFemaleInPregnantStage;
  if (
    fieldProps.fields.birthdate.month === "" ||
    fieldProps.fields.birthdate.day === "" ||
    fieldProps.fields.birthdate.year === "" ||
    parseInt(fieldProps.fields.birthdate.year) < 1900
  ) {
    isFemaleInPregnantStage = false;
    state.triageRequest.pregnant = "";
    state.triageRequest.selectChildBirth = "";
    state.triageRequest.isFemaleInPregnantStage = isFemaleInPregnantStage;
    return isFemaleInPregnantStage;
  } else {
    var dob = moment(
      fieldProps.fields.birthdate.month +
        "/" +
        fieldProps.fields.birthdate.day +
        "/" +
        fieldProps.fields.birthdate.year
    );
    var age = moment().diff(dob, "years");
    isFemaleInPregnantStage = age >= 13 && age < 60;
    if (!isFemaleInPregnantStage) {
      state.triageRequest.pregnant = "";
      state.triageRequest.selectChildBirth = "";
    }
    state.triageRequest.isFemaleInPregnantStage = isFemaleInPregnantStage;
    return isFemaleInPregnantStage;
  }
}

function isFemaleAlreadyPregnantValidation({ data }) {
  if (
    data.birthdate.month === "" ||
    data.birthdate.day === "" ||
    data.birthdate.year === "" ||
    parseInt(data.birthdate.year) < 1900
  ) {
    return false;
  } else {
    var dob = moment(
      data.birthdate.month +
        "/" +
        data.birthdate.day +
        "/" +
        data.birthdate.year
    );
    var age = moment().diff(dob, "years");
    return age >= 13 && age < 60;
  }
}
const formSchema = schema(({ string, stringOf }) => ({
  consent: stringOf("false"),
  name: string,
  travelto: string,
  travelfrom: string,
  policyNumber: string,
}));

export default ({ state, setState, actions, history, nextStepName }) => {
  state.triageRequest.activeMenu = "start"
  return(
  <div id="introsurvey">
    <div className="standby-content">
      <article className="standby-article standby-article-wide">
        <div>
          <div className="standby-page-section-inner">
            <Form
              id="entry-survey"
              className="standby-form"
              fields={state.triageRequest}
              onValidate={(data) => {
                setState({
                  isStartPageValidationStarted: true,
                });

                const errors = {};
                const required = "REQUIRED";

                let today = moment();
                if (data.birthdate.month.toString().length === 1)
                  data.birthdate.month = "0" + data.birthdate.month;
                if (data.birthdate.day.toString().length === 1)
                  data.birthdate.day = "0" + data.birthdate.day;

                let birthdate =
                  data.birthdate.year +
                  "/" +
                  data.birthdate.month +
                  "/" +
                  data.birthdate.day;
                state.triageRequest.dateofbirth = birthdate;
                let diff = today.diff(birthdate);
                let dateToValidate = moment(birthdate, "YYYY/MM/DD", true);
                sessionStorage.setItem("dateToValidate", dateToValidate.isValid());

                //check if it's valid and not in the future
                if (!dateToValidate.isValid() || diff < 0) {
                  errors.birthdate = required;
                }
                if (!data.isRiskFactorCompleted){
                  errors.riskfactorcompleted = required;
                } 
                if (data.selectRecentPhysicalInjury === "") {
                  errors.recentphysicalinjury = required;
                }
                if (data.gender === "") {
                  errors.gender = required;
                }
                if (
                  data.gender &&
                  data.gender === "F" &&
                  isFemaleAlreadyPregnantValidation({ data })
                ) {
                  if (data.pregnant === "") {
                    errors.pregnant = required;
                  }
                  if (data.selectChildBirth === "") {
                    errors.selectChildBirth = required;
                  }
                }

                if (Object.keys(errors).length) return errors;

              }}
              onSubmit={(data) => {
                const {
                  gender,
                  birthdate,
                  pregnant,
                  birthdateSelected,
                  triageSymptom,
                  selectChildBirth,
                  selectRecentPhysicalInjury,
                  riskFactorVal,
                  childBirthName,
                  isRiskFactorCompleted
                } = data;
                setState({
                  isStartPageValidationStarted: false,
                });
                state.triageRequest.data = data;

                //Prepare the data
                var today = moment();
                var dob = moment(
                  data.birthdate.month +
                    "/" +
                    data.birthdate.day +
                    "/" +
                    data.birthdate.year
                );
                var internalId = "SBMDMOBILE" + today.format("YYYYMMdhhmm");
                var days = today.diff(dob, "days");

                window.sessionStorage.setItem("identifier", internalId);
                window.sessionStorage.setItem("gender", gender);
                window.sessionStorage.setItem("dob", dob);
                window.sessionStorage.setItem("days", days);
                window.sessionStorage.setItem("pregnant", pregnant);
                window.sessionStorage.setItem("triageSymptom", triageSymptom);
                window.sessionStorage.setItem("selectChildBirth", selectChildBirth);
             
                  var isInjurySelected = "";
                  if (selectRecentPhysicalInjury === "Yes") {
                      isInjurySelected = true
                  }else if (selectRecentPhysicalInjury === "No"){
                      isInjurySelected = false
                  }
                actions.setTriageBio({
                  sessionId: new Date().getTime(),

                  gender,
                  birthdate,
                  pregnant,
                  birthdateSelected,
                  selectRecentPhysicalInjury: isInjurySelected,
                  riskFactorVal,
                  childBirthName,
                  isRiskFactorCompleted,
                  triageSymptom,
                  selectChildBirth,                  
                });

                history.push(`/find-care-options/${nextStepName}`);
              }}
            >
              {(fieldProps) => (
                <>
                  <div className="standby-article">
                    <h1 className="standby-center">
                        <Trans i18nKey="Menulist.Aboutme">About Me</Trans>
                    </h1>
                  </div>
                  <SelectBirthDate {...fieldProps} state={state} actions={actions} />
                  <SelectGender {...fieldProps} actions={actions} state={state} />
                  {fieldProps.fields.riskFactorVal && sessionStorage.getItem("dateToValidate1") === "true" &&
                  <SelectRecentPhysicalInjury  {...fieldProps} actions={actions}/> }
                  {/* Task-1913 start  */}
                  {fieldProps.fields.gender === "F" && fieldProps.fields.childBirthName &&
                  isFemaleAlreadyPregnant({ fieldProps, state }) ? (
                    <SelectPregnancyStatus actions={actions} {...fieldProps} state={state}/>
                  ) : (
                    <></>
                  )}
                  {fieldProps.fields.gender == "F" && fieldProps.fields.childBirthName &&
                  isFemaleAlreadyPregnant({ fieldProps, state }) ? (
                    <SelectChildBirth actions={actions} {...fieldProps} state={state}/>
                  ) : (
                    <></>
                  )}
                  <TriageSymptom {...fieldProps} />
                  {/* {<SelectTriageSymptom /> } */}
                  {/* end */}

                 
                  
                  <div className="standby-page-section-row standby-page-section-row-navigation p-1">
                    <button
                      type="submit"
                      className="button standby-button standby-button-gradient standby-button-square-green btn-color-contrast"
                      onClick={() => {
                        setState({
                          isLoading_ConfirmDetails: false,
                        });                        
                        gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                      }}
                    >
                      <Trans i18nKey="findcareoption.Start.Next">Next</Trans>
                    </button>
                  </div>
                  {/* <div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center">
                    <div className="standby-col standby-col-shrink standby-form-legend"></div>
                    <div className="standby-col standby-form-inline-fields pregnancy-select-container">
                      {state.isStartPageValidationStarted ? (
                        <p className="text-center color-dark-gray">
                          {  fieldProps.invalidFields.birthdate && sessionStorage.getItem("dateToValidate") == "true" ? (
                            "Date of birth cannot be greater than today or date is invalid, Please verify."
                          ) 
                          // : fieldProps.invalidFields.birthdate ? (
                          //   <Trans i18nKey="findcareoption.Start.Errormsg">
                          //     {" "}
                          //     "Required fields are empty"{" "}
                          //   </Trans>
                          // ) 
                          : fieldProps.invalidFields.gender ? (
                            <Trans i18nKey="findcareoption.Start.Errormsg">
                              {" "}
                              "Required fields are empty"{" "}
                            </Trans>
                          ) : fieldProps.fields.selectRecentPhysicalInjury == '' ? (
                            <Trans i18nKey="findcareoption.Start.Errormsg">
                              {" "}
                              "Required fields are empty"{" "}
                            </Trans>
                          ) : fieldProps.fields.gender == "F" && (fieldProps.fields.pregnant == '' || fieldProps.fields.selectChildBirth == '') ? (
                            <Trans i18nKey="findcareoption.Start.Errormsg">
                              {" "}
                              "Required fields are empty"{" "}
                            </Trans>
                          ): (
                            ""
                          )}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div> */}
                </>
              )}
            </Form>
          </div>
        </div>
      </article>
    </div>
  </div>
);}
